import Restrictions from "./Restrictions";
export default Restrictions;
